import { useContext } from "react";
import { ThemeOverrideWrapper } from "../../components/layout/themes";
import { ThemeContext } from "../../components/layout/ThemeContext";
import { useSelector } from "react-redux";
import { AppState } from "../types";

export const useThemeCustomPallete = () => {
  const brandTheme = useContext<ThemeOverrideWrapper>(ThemeContext);
  const type = useSelector((state: AppState) => state.theme);
  
  return type === "dark"
    ? brandTheme.dark?.customPalette
    : brandTheme.light?.customPalette;
};
